/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import React, { Suspense } from 'react';
import './BookingScreen.css';
import { useAppSelector } from '../state/hooks';

const BookingScreen = () => {
  const { properties, components } = useAppSelector((state) => state.configReducer);
  const globalConfig = useAppSelector((state) => state.skinReducer.globalConfig);
  const { currentSteps } = useAppSelector((state) => state.settingsReducer);

  if (window.DEBUG) console.log(properties, components);
  const BookingScreen: React.ElementType = () => {
    return (
      <div
        style={{
          backgroundColor:
            properties.styleStep[currentSteps[currentSteps.length - 1] - 1] === 2
              ? globalConfig.primary.activeBackground
              : globalConfig.primary.defaultBackground,
        }}
        className="centerScreen">
        <Suspense
          fallback={
            <div>
              <p>Lädt ...</p>
            </div>
          }>
          {Object.entries(components).map(([componentName, component], index) => {
            let tmpElement = null;
            if (
              component != null &&
              component.properties.showOnSteps.includes(currentSteps[currentSteps.length - 1])
            ) {
              const Element = React.lazy(
                () =>
                  import(
                    /* webpackChunkName: "[request]" */ `../../src/components/${component.properties.name}`
                  ),
              );
              tmpElement = <Element {...component} key={`${componentName}_${index}`} />;
            }
            return tmpElement;
          })}
        </Suspense>
      </div>
    );
  };

  return <div>{<BookingScreen />}</div>;
};

export default BookingScreen;
